let Cart = function () {
    let cartJsonStr = localStorage.getItem('cart')
    if(!cartJsonStr) return
    this.cart = JSON.parse(cartJsonStr)
}

Cart.prototype.check = function (id, qty) {
    if(!id || id==="" || typeof id !== "string") throw "cannot find item id"
    if(!qty || qty==="" || typeof qty !== "string") throw "cannot find qty"
}

Cart.prototype.put = function (id, qty, count, replace=false) {
    this.check(id, qty)
    count = parseInt(count)
    if(this.has(id)) {
        let itemCap = this.cart[id].capacity
        if(replace || !itemCap.hasOwnProperty(qty)) {
            itemCap[qty] = 0
        }
        itemCap[qty] += count
    } else {
        this.cart[id] = this.makeItem(id, qty, count)
    }
    let c = this.cart[id].capacity[qty]
    if(c <= 0) {
        this.cart[id].capacity[qty] = 1
    } else if(c > 999) {
        this.cart[id].capacity[qty] = 999
    }
    this.commit()
}

Cart.prototype.get = function (id) {
    /*
    {id: '', capacity: {qty: count, ...}, item: {...}]}
    */
    return this.cart[id]
}

Cart.prototype.has = function (id) {
    return this.cart.hasOwnProperty(id)
}

Cart.prototype.rm = function (id, qty) {
    this.check(id, qty)
    if(!this.cart.hasOwnProperty(id)) throw 'cannot find id in the cart'
    if(!this.cart[id].capacity.hasOwnProperty(qty)) throw 'cannot find qty in capacity of the cart'
    delete this.cart[id].capacity[qty]
    if(Object.keys(this.cart[id].capacity).length === 0)
        delete this.cart[id]
    this.commit()
}

Cart.prototype.clear = function () {
    this.cart = {}
    this.commit()
}

Cart.prototype.isEmpty = function () {
    return this.ls().length === 0
}

Cart.prototype.commit = function () {
    localStorage.setItem('cart', JSON.stringify(this.cart))
}

Cart.prototype.makeItem = function (id, qty, count) {
    return {
        id,
        capacity: {
            [qty]: count
        },
    }
}

Cart.prototype.ls = function () {
    return Object.values(this.cart)
}

Cart.prototype.cart = {}

let myCart = new Cart()

export default myCart
